import React from "react";

import { css } from "@emotion/css";
import Img1 from "../../../img/png/about/hero/img1.png";
import Img2 from "../../../img/png/about/hero/img2.png";
import Img3 from "../../../img/png/about/hero/img3.png";
import Img41 from "../../../img/png/about/hero/img41.png";
import Img42 from "../../../img/png/about/hero/img42.png";
import Img43 from "../../../img/png/about/hero/img43.png";
import Img5 from "../../../img/png/about/hero/img5.png";
import TitleImg from "../../../img/png/about/hero/title.png";
import TitleMImg from "../../../img/png/about/hero/title-mobile.png";
import TitleTImg from "../../../img/png/about/hero/title-tablet.png";
import BG from "../../../img/jpg/about/hero/purpose-bg.jpg";
import SunIcon from "../../../img/svg/about/sun.svg";
import {
  desktop,
  desktopBig,
  laptop,
  tablet,
} from "../../../styles/breakpoints";
import { useIsMobile } from "../../../components/helpers/ScreenCheck";
import { useI18n } from "../../../i18n";

const Multiple = ({ isDesktopBig = true }) => (
  <div className={`wrapper ${isDesktopBig ? "desktopBig" : "desktop"}`}>
    <img src={Img41} alt="" className="img4" />
    <img src={Img42} alt="" className="img4" />
    <img src={Img43} alt="" className="img4" />
  </div>
);
const Hero = () => {
  const isMobile = useIsMobile(744);
  const isLaptop = useIsMobile(1023);
  const { t } = useI18n();

  return (
    <div className={style.main}>
      <div className={style.hero}>
        <img src={Img1} alt="" className="img1" />
        <div className="row">
          <img src={Img2} alt="" className="img2" />
        </div>
        <div className="row">
          <Multiple isDesktopBig={false} />
          <img src={Img3} alt="" className="img3" />
        </div>
        <Multiple />
        <img src={Img5} alt="" className="img5" />
      </div>
      <div className={style.purpose}>
        <div className="wrapper">
          <img
            src={isMobile ? TitleMImg : isLaptop ? TitleTImg : TitleImg}
            alt={t("about_purpose")}
            className="title"
          />
          <h5>
            {t("about_purpose_body")}
          </h5>
          <p>
            {t("about_hero_tech")}
            <br />
            <br />
            {t("about_hero_identity")}
            <br />
            <br />
            <b>{t("about_hero_self")}</b>
          </p>
          <img src={SunIcon} alt={t("about_alt_sun")} className="sun" />
        </div>
      </div>
    </div>
  );
};

const style = {
  main: css({
    background:
      "linear-gradient(185deg, #FFD5FA -0.88%, #FFF3E6 9.96%, #FFF3E6 48.8%, #FFF 66.19%)",
    overflow: "hidden",
    [desktopBig]: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
    },
  }),
  purpose: css({
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 73,
    marginBottom: 40,
    width: '100%',

    ".wrapper": {
      maxWidth: 1348,
      width: '100%',
      height: 1344,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "top center",
      backgroundSize: "auto",
      backgroundImage: `url(${BG})`,
      borderRadius: 30,
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",

      ".title": {
        width: 674,
        height: 368,
        marginBottom: 44,
      },
      ".sun": {
        width: 157.576,
        height: 157.282,
      },
      h5: {
        color: "#C89AFF",
        textAlign: "center",
        fontFamily: "Syne",
        fontSize: 32,
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "40.95px",
        marginBottom: 49,
        maxWidth: 711,
      },
      p: {
        color: "#202122",
        textAlign: "center",
        fontFamily: "Inter",
        fontSize: 18,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "26.4px",
        marginBottom: 100,
        maxWidth: 711,
      },
    },
    [desktop]: {
      marginTop: 100,
      ".wrapper": {
        marginLeft: 30,
        marginRight: 30,
        height: 1375,
      },
    },
    [laptop]: {
      ".wrapper": {
        height: 892.338,
        backgroundSize: "cover",

        ".title": {
          width: 539,
          height: "auto",
          marginBottom: -280,
        },
        ".sun": {
          width: 104.406,
          height: 104.212,
        },
        h5: {
          fontSize: 28,
          marginBottom: 32,
          maxWidth: 495,
        },
        p: {
          fontSize: 14,
          lineHeight: "17.5px",
          maxWidth: 423,
          marginBottom: 42,
        },
      },
    },
    [tablet]: {
      marginTop: 100,
      ".wrapper": {
        height: 900,
        marginLeft: 20,
        marginRight: 20,
        backgroundSize: "cover",

        ".title": {
          width: 324,
          height: "auto",
          marginBottom: 10,
        },
        ".sun": {
          width: 104.406,
          height: 104.212,
        },
        h5: {
          fontSize: 20,
          lineHeight: "24px",
          maxWidth: 304,
        },
        p: {
          fontSize: 12,
          lineHeight: "17.5px",
          maxWidth: 286,
          marginBottom: 36,
        },
      },
    },
  }),
  hero: css({
    marginTop: 110,
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    gap: 20,
    ".row": {
      display: "flex",
      flexDirection: "column",
      gap: 5,
    },
    ".desktopBig": {
      display: "flex !important",
    },
    ".desktop": {
      display: "none !important",
    },
    ".img1": {
      width: 409,
      height: 987,
    },
    ".img2": {
      width: 672,
      height: 987,
    },
    ".img3": {
      width: 866.855,
      height: 987,
    },
    ".img4": {
      width: 313,
      height: 309.482,
    },
    ".img5": {
      width: 392,
      height: 959,
    },
    ".wrapper": {
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      gap: 10,
    },
    [desktopBig]: {
      gap: 10,
      maxWidth: 1348,
      marginLeft: 30,
      marginRight: 30,

      ".row": {
        display: "flex",
        flexDirection: "column",
        gap: 5,
        width: "50%",
      },
      ".desktopBig": {
        display: "none !important",
      },
      ".desktop": {
        display: "flex !important",
      },
      ".wrapper": {
        flexDirection: "row",
        gap: 5,
      },
      ".img1, .img5": {
        display: "none",
      },
      ".img2": {
        width: "100%",
        height: "auto",
        maxWidth: 890,
      },
      ".img3": {
        width: "100%",
        height: "auto",
        maxWidth: 890,
      },
      ".img4": {
        width: "33.33%",
        height: "auto",
      },
    },
    [desktop]: {},
    [laptop]: {
      flexDirection: "column",

      ".row": {
        width: "100%",
      },
    },
    [tablet]: {
      marginTop: 90,
      marginLeft: 20,
      marginRight: 20,
    },
  }),
};

export default Hero;
